import { render, staticRenderFns } from "./_fileBackupsNotesModal.vue?vue&type=template&id=cbf9ac04"
import script from "./_fileBackupsNotesModal.vue?vue&type=script&lang=js"
export * from "./_fileBackupsNotesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports